import React from "react";
import { View, Image, Text, StyleSheet } from "@react-pdf/renderer";

const HeaderPDF = () => (
    <View style={styles.flex}>
      <Image
        source="data:image/jpeg;base64,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"
        style={styles.img}
      />
      <Text style={styles.boderLeft} />

      <View style={styles.container}>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>Medical Equipment</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>Laboratory Equpment</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>Hospital Furniture</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>Consumable</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>Repairs And Maitenance</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>E-Health</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.boder} />
          <Text style={styles.text}>Consultancy</Text>
        </View>
      </View>
      <Text style={styles.boderLeft1} />
      <View style={styles.address}>
        <Text style={styles.office}>HEAD OFFICE</Text>
        <Text style={styles.plot}>plot No 10 Trade Fair</Text>
        <Text style={styles.layout}>Layout off Zoo Road, Kano</Text>
        <Text style={styles.branches}>BRANCHES</Text>
        <Text style={styles.zoo}>No. 8 Zoo Road,Kano</Text>
        <Text style={styles.sultan}>No. 64 Sultan Abubakar Rd, Sokoto</Text>
        <View style={styles.flex}>
          <Text style={styles.office}>E-MAIL: </Text>
          <Text style={styles.mail}>info@minjirya.com</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.office}>WEB-SITE: </Text>
          <Text style={styles.mail}>www.minjirya.com</Text>
        </View>
        <View style={styles.flex}>
          <Text style={styles.office}>TEL:</Text>
          <Text style={styles.mail}>+2348123911566</Text>
        </View>
        <Text style={styles.phone}>+2348033301189</Text>
      </View>
    </View>
);

export default HeaderPDF;

const styles = StyleSheet.create({
  boderLeft1: {
    borderBottom: "2 solid black",
    width: 120,
    transform: "rotate(90deg)",
    position: "absolute",
    left: 305,
    top: 70,
  },
  phone: {
    fontSize: 8,
    marginLeft: 23,
  },
  mail: {
    fontSize: 8,
    marginTop: 1,
    marginLeft: 1,
  },
  sultan: {
    fontSize: 8,
  },
  zoo: {
    fontSize: 8,
  },
  branches: {
    fontSize: 10,
    marginTop: 2,
  },
  layout: {
    fontSize: 8,
  },
  address: {
    marginLeft: 250,
    marginTop: 10,
  },
  col: {
    width: 200,

    border: 1,
    padding: 10,
  },
  headerContainer: {
    width: 400,
    height: 400,
    border: "1px solid #c3c3c3",
    display: "flex",
    flexDirection: "row-reverse",
  },
  table: {
    display: "grid",
    gridTemplateColumns: "repeat(5,1fr)",
    borderTop: "1 solid black",
  },
  flex1: {
    flexDirection: "row",
    margin: 12,
  },
  no: {
    marginLeft: 470,
    fontSize: 12,
    position: "relative",
    bottom: 20,
  },
  dotted: {
    borderBottom: "1 dotted black",
    width: 270,
  },
  form: {
    border: "2 solid black",
    textAlign: "center",
    marginTop: 10,
    borderRadius: 25,
    padding: 5,
    marginLeft: 100,
    marginRight: 100,
    backgroundColor: "black",
    color: "white",
  },

  office: {
    fontSize: 10,
    marginTop: 2,
  },
  plot: {
    fontSize: 7,
  },
  body: {
    padding: 30,
  },
  container: {
    position: "absolute",
    left: 200,
    top: 10,
  },
  head: {
    position: "absolute",
    left: 400,
  },
  img: {
    width: 150,
  },
  flex: {
    flexDirection: "row",
  },
  boderLeft: {
    borderBottom: "2 solid black",
    width: 120,

    transform: "rotate(90deg)",
    position: "absolute",
    left: 110,
    top: 70,
  },
  boder: {
    border: "2 solid black",
    borderRadius: 25,
    width: 7,
    height: 7,
    margin: 5,

    backgroundColor: "black",
  },

  text: {
    fontSize: 14,

    fontFamily: "Times-Roman",
  },
  receiptNo: {
    display: "flex",
    alignContent: "center",
  },
});
